import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ServiceHistory } from '../../models/service-history';
import { ServicesHistoryervice } from '../../services/serviceHistoryService';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-add-version',
  templateUrl: './add-version.component.html',
  styleUrls: ['./add-version.component.scss'],
})
export class AddVersionComponent implements OnInit {
  serviceId: number;
  serviceHistory: ServiceHistory = {} as ServiceHistory;
  inputlist: any[] = [];

  constructor(
    private diagref: NbDialogRef<AddVersionComponent>,
    private service: ServicesHistoryervice,
    private toast: NbToastrService,
    private route: Router
  ) {}
  addinput() {
    this.serviceHistory.featuresfront.push({ value: '' });
  }
  ngOnInit() {
          this.route.events.subscribe(()=>{
      this.diagref.close('false');
  })
    this.serviceHistory.updates = '';
    this.serviceHistory.serviceId = this.serviceId;
    this.serviceHistory.featuresfront = [{ value: '' }];
    this.serviceHistory.features = [];
  }
  public tools: object = {
    items: [
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      '|',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      '|',
      'LowerCase',
      'UpperCase',
      '|',
      'Undo',
      'Redo',
      '|',
      'Formats',
      'Alignments',
      '|',
      'OrderedList',
      'UnorderedList',
      '|',
      'Indent',
      'Outdent',
      '|',
      'CreateLink',
      'CreateTable',
      'Image',
      '|',
      'ClearFormat',
      'Print',
      'SourceCode',
      '|',
      'FullScreen',
    ],
  };

  save() {
    this.serviceHistory.featuresfront.forEach((a) => {
      this.serviceHistory.features.push(a.value);
    });
    this.service.post(this.serviceHistory).subscribe((a) => {
      this.toast.show('حفظ اصدار', 'تم حفظ الاصدار الجديد بنجاح', { status: 'primary', duration: 3000 });
      this.diagref.close('true');
    });
  }

  close() {
    this.diagref.close();
  }
}
